import React from "react";
import { MapContainer, TileLayer, AttributionControl } from "react-leaflet";
import CustomMarkerSingleStation from "./CustomMarkerSingleStation";

const MapOfEachStation = (props) => {
  return (
    <MapContainer
      style={{ width: "98%", height: 450 }}
      center={[props.information.latitude, props.information.longitude]}
      zoom={10}
      attributionControl={false}
    >
      <CustomMarkerSingleStation
        position={[props.information.latitude, props.information.longitude]}
        information={props.information}
        aqi={props.information.AQI}
        selectedType={props.selectedType}
        type="singleStation"
      />
      <TileLayer
        attribution="ایستگاه کنترل کیفیت هوا"
        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <AttributionControl position="bottomright" prefix={false} />
    </MapContainer>
  );
};

export default MapOfEachStation;
